var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count > 0)?_c('a',{staticClass:"like-count",on:{"click":_vm.openLikersDialog}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-thumb-up")]),_c('span',{domProps:{"textContent":_vm._s(_vm.count)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }